<template>
  <section
    class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 print:grid-cols-3 gap-6"
  >
    <MetricCard
      label="Total de Empresas"
      :value="cards?.companies_count ?? 0"
      highlight
      class="print:hidden"
    />

    <MetricCard
      label="Total de Respondentes"
      :value="cards?.respondents_count ?? 0"
      rightbottom
    />

    <MetricCard
      label="Total de Setores"
      :value="cards?.roles_count ?? 0"
      righttop
    />

    <MetricCard
      :label="cards?.main_indicator?.label || 'Indicador Principal'"
      :value="mainValue"
      center
    >
      <div
        v-show="Object.keys(summary).length > 0"
        class="text-sm"
        :class="classificationClass(summary)"
      >
        {{ summary }}
      </div>
    </MetricCard>

    <!-- <div
      v-if="cards?.main_indicator?.classification?.label"
      class="md:col-span-2 xl:col-span-4 -mt-2"
    >
      <div class="text-sm text-slate-500">
        Classificação:
        <span class="font-semibold text-slate-700">
          {{ cards.main_indicator.classification.label }}
        </span>
      </div>
    </div> -->
  </section>
</template>

<script setup>
import { computed, defineProps } from "vue";
import MetricCard from "./MetricCard.vue";

const props = defineProps({
  cards: {
    type: Object,
    default: () => ({
      companies_count: 0,
      respondents_count: 0,
      roles_count: 0,
      main_indicator: {
        label: "",
        value: 0,
        display: "0",
        suffix: null,
        classification: null,
      },
    }),
  },
  summary: {
    type: Object,
    default: () => ({}),
  },
});

const classificationClass = (key) => {
  if (key === "Favorável") return "text-emerald-400 print:font-bold";
  if (key === "Risco à saúde") return "text-rose-400 print:font-bold";
  return "text-amber-400 print:text-yellow-600 print:font-extrabold";
};

const mainValue = computed(() => {
  return props.cards?.main_indicator?.display ?? "0";
});
</script>
